import React from 'react';
import PropTypes from 'prop-types';
import { Skeleton } from '@womcorp/wom-miwom-ui-kit/dist/components/Skeleton';
import {
  SkeletonTitle,
  SkeletonContainer,
  SkeletonContainerInfoRightStyled,
  SkeletonContainerInfoStyled,
  SkeletonContainerInfoLeftStyled,
  SkeletonContainerInfoTwoStyled,
  SkeletonContainerInfoThreeStyled,
  SkeletonContainerInfoCombinedStyled,
  SkeletonMultiAccountBottomStyled,
  SkeletonBottomMultiAccountStyled,
} from './styles/StatusSkeletonStyled';

const StatusSkeleton = ({ isMultiAccount }) => {
  return (
    <>
      <SkeletonContainer isMultiAccount={isMultiAccount}>
        <div>
          <SkeletonTitle>
            <Skeleton variant="rounded" />
          </SkeletonTitle>
        </div>
        <SkeletonContainerInfoStyled>
          <SkeletonContainerInfoCombinedStyled>
            <SkeletonContainerInfoLeftStyled>
              <Skeleton variant="rounded" />
              <Skeleton variant="rounded" />
            </SkeletonContainerInfoLeftStyled>
            <SkeletonContainerInfoRightStyled>
              <Skeleton variant="rounded" />
              <Skeleton variant="rounded" />
            </SkeletonContainerInfoRightStyled>
          </SkeletonContainerInfoCombinedStyled>
          <SkeletonContainerInfoTwoStyled>
            <Skeleton variant="rounded" />
            <Skeleton variant="rounded" />
          </SkeletonContainerInfoTwoStyled>
          <SkeletonContainerInfoThreeStyled isMultiAccount={isMultiAccount}>
            <Skeleton variant="rounded" />
            <Skeleton variant="rounded" />
          </SkeletonContainerInfoThreeStyled>
        </SkeletonContainerInfoStyled>
      </SkeletonContainer>
      {isMultiAccount && (
        <SkeletonMultiAccountBottomStyled>
          <SkeletonBottomMultiAccountStyled>
            <Skeleton variant="rounded" />
          </SkeletonBottomMultiAccountStyled>
        </SkeletonMultiAccountBottomStyled>
      )}
    </>
  );
};

StatusSkeleton.propTypes = {
  isMultiAccount: PropTypes.bool.isRequired,
};

export default StatusSkeleton;
